
import { Reducer } from 'umi';



export interface ProgressState {
    progress: number
}

export interface UploadProgress {
    namespace: string;
    state: ProgressState;
    reducers: {
        changeProgress: Reducer<ProgressState>;
    };
}

const progressModel: UploadProgress = {
    namespace: 'progress',
    state: {
        progress: 0,
    },
    reducers: {
        changeProgress(state, { payload }) {
            return {
                ...state,
                progress: payload
            };
        },
    },
};

export default progressModel;
